import React, { useState } from "react";
import MuiToolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MenuIcon from "@material-ui/icons/Menu";
import { useTheme } from "@material-ui/styles";
import Link from "components/Router/Link";
import { useMediaQuery } from "@material-ui/core";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import { IRootState } from "shared/reducer";

interface IToolbarProps {
	onMobileDrawerOpen: (state: boolean) => void;
	isMobileDrawerOpen: boolean;
}

const Toolbar = ({
	onMobileDrawerOpen,
	isMobileDrawerOpen = false
}: IToolbarProps) => {
	const classes = useStyles();
	const { breakpoints } = useTheme();
	const matches = useMediaQuery(breakpoints.down("md"));
	const [anchorEl, setAnchorEl] = useState<Element | null>(null);
	const account = useSelector(
		({ authentication }: IRootState) => authentication.account
	);

	const handleClick = (event: React.SyntheticEvent) =>
		setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	function handleDrawerOpen() {
		if (matches) {
			onMobileDrawerOpen(true);
		}
	}

	return (
		<MuiToolbar className={classes.toolbar}>
			<Grid container direction="row" justify="space-between" alignItems="center">
				<Grid item className={classes.toolbarElement}>
					<IconButton
						color="inherit"
						aria-label="Open drawer"
						onClick={handleDrawerOpen}
						className={classes.menuButton}
					>
						<MenuIcon />
					</IconButton>
					<Typography variant="h4" className={classes.siteName}>
						REG Utánfutó
					</Typography>
				</Grid>
				<Grid item className={classes.toolbarElement}>
					<Button color="inherit" variant="text" onClick={handleClick}>
						<Typography variant="h4" className={classes.userName}>
							{account.name}
						</Typography>
						<AccountCircleIcon />
					</Button>
					<Menu
						id="account-menu"
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={handleClose}
					>
						<MenuItem component={Link} to="/account">
							Profil
						</MenuItem>
						<MenuItem component={Link} to="/account/password">
							Jelszó módosítása
						</MenuItem>
						<MenuItem component={Link} to="/account/update">
							Fiókadatok módosítása
						</MenuItem>
						<MenuItem component={Link} to="/logout">
							Kijelentkezés
						</MenuItem>
					</Menu>
				</Grid>
			</Grid>
		</MuiToolbar>
	);
};

export default Toolbar;
